import { DateTime } from "luxon"
import { LeadCount } from "../../types"
import { getMonth } from "."

export interface MonthlyLeadCount {
  month: string
  year: string
  count: number
}

/**
 * Groups daily lead count data into monthly totals by year.
 */
export const groupLeadCountByMonth = (
  leadCounts: LeadCount[]
): MonthlyLeadCount[] => {
  const totals = leadCounts.reduce<Record<string, number>>((acc, item) => {
    const date = DateTime.fromISO(item.timestamp_tz_date)
    if (!date.isValid) return acc

    const key = `${date.year}-${date.month}` // e.g. "2025-9"
    acc[key] = (acc[key] || 0) + item.lead_count
    return acc
  }, {})

  // Sort by year then month
  const sortedKeys = Object.keys(totals).sort((a, b) => {
    const [yearA, monthA] = a.split("-").map(Number)
    const [yearB, monthB] = b.split("-").map(Number)
    return yearA === yearB ? monthA - monthB : yearA - yearB
  })

  return sortedKeys.map(key => {
    const [year, month] = key.split("-").map(Number)
    return {
      month: getMonth(year, month),
      year: year.toString(),
      count: totals[key]
    }
  })
}
